import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DiamondIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Diamond",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16.01 28.54c-.26 0-.51-.1-.71-.29l-15.01-15a.984.984 0 0 1 0-1.4l7.85-8.09c.19-.19.45-.3.72-.3h14.07c.27 0 .52.11.71.29l8.08 8.08c.39.39.39 1.02 0 1.41l-14.99 15c-.19.2-.45.29-.71.29ZM2.4 12.53 16 26.13l13.58-13.59-7.08-7.08H9.27z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M30.79 13.54H1.5c-.55 0-1-.45-1-1s.45-1 1-1h29.29c.55 0 1 .45 1 1s-.45 1-1 1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.01 28.54c-.39 0-.74-.23-.91-.58l-6.92-15c-.23-.5-.01-1.1.49-1.33s1.1-.01 1.33.49l6.01 13.03 6.02-13.03c.23-.5.83-.72 1.33-.49s.72.83.49 1.33l-6.92 15c-.16.35-.52.58-.91.58Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.08 13.54a.999.999 0 0 1-.76-1.65l6.92-8.08c.19-.22.47-.35.76-.35s.57.13.76.35l6.93 8.08a.999.999 0 1 1-1.52 1.3L16 6l-6.16 7.19c-.2.23-.48.35-.76.35"
    })]
  }));
};
DiamondIcon.displayName = 'DiamondIcon';